import React from 'react';
import { InstagramIcon, PhoneIcon, MailIcon } from 'lucide-react';
import { ImdbIcon } from './ImdbIcon';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="bg-gray-950 py-12 w-full" data-id="element-127">
      <div className="container mx-auto px-4 md:px-6" data-id="element-128">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-129">
          <div data-id="element-130">
            <h3 className="text-xl font-bold mb-4" data-id="element-131">Blue Rain Productions</h3>
            <p className="text-gray-400 mb-6" data-id="element-132">
              Professionele film en series productie door Martijn Mantel.
            </p>
            <div className="flex space-x-4" data-id="element-133">
              <a href="https://www.instagram.com/martijn_mantel/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors" data-id="element-134">
                <InstagramIcon size={20} data-id="element-135" />
              </a>
              <a href="https://www.imdb.com/name/nm10911429/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors" data-id="element-136">
                <ImdbIcon size={20} data-id="element-137" />
              </a>
            </div>
          </div>
          <div data-id="element-138">
            <h3 className="text-xl font-bold mb-4" data-id="element-139">Navigatie</h3>
            <ul className="space-y-3" data-id="element-140">
              <li data-id="element-141">
                <Link to="/" className="text-gray-400 hover:text-blue-400 transition-colors" data-id="element-142">
                  Home
                </Link>
              </li>
              <li data-id="element-143">
                <a href="/#about" className="text-gray-400 hover:text-blue-400 transition-colors" data-id="element-144">
                  Over ons
                </a>
              </li>
              <li data-id="element-145">
                <Link to="/producties" className="text-gray-400 hover:text-blue-400 transition-colors" data-id="element-146">
                  Producties
                </Link>
              </li>
              <li data-id="element-147">
                <a href="/#contact" className="text-gray-400 hover:text-blue-400 transition-colors" data-id="element-148">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-149">
            <h3 className="text-xl font-bold mb-4" data-id="element-150">Juridisch</h3>
            <ul className="space-y-3" data-id="element-151">
              <li data-id="element-152">
                <Link to="/privacy" className="text-gray-400 hover:text-blue-400 transition-colors" data-id="element-153">
                  Privacyverklaring
                </Link>
              </li>
              <li data-id="element-154">
                <Link to="/cookies" className="text-gray-400 hover:text-blue-400 transition-colors" data-id="element-155">
                  Cookieverklaring
                </Link>
              </li>
              <li data-id="element-156">
                <Link to="/voorwaarden" className="text-gray-400 hover:text-blue-400 transition-colors" data-id="element-157">
                  Algemene voorwaarden
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-158">
            <h3 className="text-xl font-bold mb-4" data-id="element-159">Contact</h3>
            <div className="text-gray-400 space-y-2" data-id="element-160">
              <div className="flex items-center" data-id="element-161">
                <PhoneIcon size={16} className="mr-2" data-id="element-162" />
                <p data-id="element-163">+31651764541</p>
              </div>
              <div className="flex items-center" data-id="element-164">
                <MailIcon size={16} className="mr-2" data-id="element-165" />
                <p data-id="element-166">info@bluerainproductions.nl</p>
              </div>
            </div>
            <div className="mt-4 text-gray-400 text-sm" data-id="element-167">
              <p data-id="element-168">KvK: 93937369</p>
              <p data-id="element-169">BTW: NL005053538B76</p>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-170">
          <p className="text-gray-400 text-sm mb-4 md:mb-0" data-id="element-171">
            &copy; {new Date().getFullYear()} Blue Rain Productions. Alle
            rechten voorbehouden.
          </p>
          <div className="text-gray-500 text-sm" data-id="element-172">
            <p data-id="element-173">
              Made with{' '}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="inline-block w-4 h-4 text-red-500 mx-0.5 align-text-bottom" data-id="element-174">
                <path d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" data-id="element-175" />
              </svg>{' '}
              by{' '}
              <a href="https://radux.nl" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:text-blue-300 transition-colors" data-id="element-176">
                Radux
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>;
};